module.exports = ".prepender{\r\n    width: 30%;\r\n}\r\n.prepender-text{\r\n    width: 100%;\r\n}\r\n"